import React, { Component } from 'react'
import {connect} from 'react-redux';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

import './CategoryBar.css';

class CategoryBar extends Component {

    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            isOpen: false,
        }
    }

    toggleCategory = () => {
        this.setState(prevState => ({
            isOpen : !prevState.isOpen
        }))
    }

    render(){

        const categoryDropdown = 
            <React.Fragment>
                {this.props.category.mainCategory.map((obj, idx)=>{
                    return (
                        <React.Fragment>
                            <DropdownItem 
                                active={this.props.currentCategory === idx}
                                onClick={()=>this.props.categoryClickHandler(idx, -1, obj.id)}>{obj.text[this.props.lang]}</DropdownItem>

                            {
                                this.props.category.subCategory[idx].sort((a, b) => {
                                    return a.text.order - b.text.order;
                                }).map((o, i) => {
                                    return (
                                        <DropdownItem
                                            active={this.props.currentCategory === o.id} key={i}
                                            onClick={()=>this.props.categoryClickHandler(idx, i, o.id)}>{"- "+o.text[this.props.lang]}</DropdownItem>
                                    )
                                })
                                // this.props.category.subCategory[idx].map((o, i)=>{
                            }
                            <DropdownItem divider></DropdownItem>
                        </React.Fragment>
                    )
                })}
            </React.Fragment>
        let currentCategoryName = null;

        if(this.props.currentCategory !== "all"){
            for(var i in this.props.category.mainCategory){
                if(this.props.category.mainCategory[i].id === this.props.currentCategory){
                    currentCategoryName = this.props.category.mainCategory[i].text[this.props.lang];
                }
            }
            let subCategories = [];
            for(var i in this.props.category.subCategory){
                subCategories = [...this.props.category.subCategory[i], ...subCategories]
            }
            for(var i in subCategories){
                if(subCategories[i].id === this.props.currentCategory){
                    currentCategoryName = "- " + subCategories[i].text[this.props.lang];
                }
            }
        }    
        
        return(
            <div className="category-bar">
                <span className="title">
                    제품 리스트
                </span>
                <Dropdown size="lg" group className="float-right"isOpen={this.state.isOpen} toggle={this.toggleCategory}>
                    <DropdownToggle caret>
                        {this.props.currentCategory === "all" ? 
                            {en: "Select Category", ko: "카테고리 선택"}[this.props.lang] : 
                            currentCategoryName
                        }
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem
                            active={this.props.currentCategory === "all"}
                            onClick={()=>this.props.categoryClickHandler(-1, -1, "all")}>
                            <strong>{{en: "All", ko: "전체"}[this.props.lang]}</strong>
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        {categoryDropdown}
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        lang : state.universal.language,
        category : state.category,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return{

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryBar);



// WEBPACK FOOTER //
// ./src/pages/Store/CategoryBar.js